<template>
  <div class="area_ui">
    <div class="area-box" v-if="curZone.code">
      <div class="area-name" @click="showBox"><i class="iconweizhi2 iconfont"></i>{{curZone.descript}}</div> 

    </div>

  </div>
</template>
<script>
import {
  setStorage,
  getStorage,
  removeStorage,
  openLocation,
} from "@/utils/wxuser";
import api from "@/utils/api";
import { isWeChat } from "@/utils/utils";
var config = {};
import { jAlert3, jAlert5 } from "@/base/jAlert/jAlert";
export default {
  props: ["datas"],
  data() {
    return {
      showArea: false,
      zoneList: [],
      curZone: {},
      location: {},
    };
  },

  methods: {
    chooseArea(item) {
      var domain = item.domain || ''
      window.location.href = `${domain}/mall2/?/#/polymerization?id=${item.aggregateId}`
    },
    showBox() {
      this.$router.push({
        path: "/chooseHotel",
        query:{
          form:'area'
        }
      })
    },
    rad(d) {
      return d * Math.PI / 180.0;
    },
    getDistance(lat1, lng1, lat2, lng2) {

      var radLat1 = this.rad(lat1);
      var radLat2 = this.rad(lat2);
      var a = radLat1 - radLat2;
      var b = this.rad(lng1) - this.rad(lng2);
      var s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) +
        Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)));
      s = s * 6378.137; // EARTH_RADIUS;
      s = Math.round(s * 10000) / 10000; //输出为公里

      var distance = s;
      var distance_str = "";

      if (parseInt(distance) >= 1) {
        distance_str = distance.toFixed(1) + "公里";
      } else {
        distance_str = distance * 1000 + "米";
      }
      var distances = {
        distance: s,
        distance_str: distance_str
      }
      console.info('距离是', s);
      console.info('距离是', distance_str);
      return distances;
    },
    selectHotelGroupAggregate() {
      var opt = {
        hotelGroupCode: config.hotelGroupCode
      }
      api.selectHotelGroupAggregate(opt).then((res) => {
        if (res.result == 1) {
          this.zoneList = res.retVal
          if (this.zoneList.length > 0) {
            this.findGcZoneList()
          } else {
            this.$emit('updateArea', false)
          }
        } else {
          jAlert3(res.msg);
        }
      })
    },
    findGcZoneList() {
      let opt = {
        hotelGroupCode: config.hotelGroupCode
      };
      api.findGcZoneList(opt).then((res) => {
        if (res.result == 1) {
          if (res.retVal.resultCode == 0) {
            this.zoneList.forEach((item, i) => {
              res.retVal.resultInfo.forEach(zone => {
                if (item.zoneCode == zone.code) {
                  var aggregateId = item.aggregateId
                  this.zoneList[i] = zone
                  this.zoneList[i].aggregateId = aggregateId

                }
              })
            })
            if (this.zoneList.length > 0) {
              this.zoneList.forEach((item, i) => {
                if (this.datas.zoneCode == item.code) {
                  this.curZone = item
                }

              })
            }
            var zoneIndex = sessionStorage.getItem('zoneIndex')

            if (this.location.latitude && this.zoneList.length > 0) {
              var minDistance = ''
              var minIndex = 0
              this.zoneList.forEach((item, i) => {
                if (item.latitude != undefined) {
                  item.distance = this.getDistance(this.location.latitude, this.location.longitude, item.latitude, item.longitude).distance
                  item.distance_str = this.getDistance(this.location.latitude, this.location.longitude, item.latitude, item.longitude).distance_str

                  if (minDistance == '') {
                    minIndex = i
                    minDistance = item.distance
                  } else {
                    console.log(item.distance, minDistance)
                    if (item.distance < minDistance) {
                      minIndex = i
                      minDistance = item.distance
                    }
                  }
                }
              })

              if (zoneIndex != null && this.zoneList[zoneIndex] && this.zoneList[zoneIndex].code) {
                this.chooseArea(this.zoneList[zoneIndex], zoneIndex)
              } else {
                var zoneChoose =  sessionStorage.getItem('zoneChoose')

                if (this.zoneList[minIndex].code != this.curZone.code &&zoneChoose==null) {
                  sessionStorage.setItem('zoneChoose',true)
                  jAlert5(`当前距<b style="font-weight:bold;">${this.zoneList[minIndex].descript}</b>最近，是否切换`, () => {
                    this.chooseArea(this.zoneList[minIndex], minIndex)
                  })
                }
              }
            }
            setStorage('hotelList', this.zoneList)



          } else {
            jAlert3(res.retVal.resultMessage)
          }
        } else {
          jAlert3(res.msg);
        }
      });
    },

    handleLocation() {
      var obj = {};
      obj.latitude = this.curZone.latitude;
      obj.longitude = this.curZone.longitude;
      obj.name = this.curZone.descript;
      // obj.address = this.goodsDetail.address;
      openLocation(obj);
    },
  },
  mounted() {
    if (isWeChat()) {
      wx.ready(() => {
        wx.getLocation({
          type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
          success: (res) => {
            this.location = res
            this.selectHotelGroupAggregate()
          }, fail: (er) => {
            this.selectHotelGroupAggregate()
            console.log(er)
          }, complete: (res) => {
            this.selectHotelGroupAggregate()
          }
        });
      })
    } else {
      this.selectHotelGroupAggregate()
    }
  },
  computed: {

  },
  created() {
    config = getStorage("config");
  },


};
</script>
<style lang="less" scoped>
@import url("~@/styles/mixin.less");
@import url("~@/styles/base.less");
.area_ui {
  position: absolute;
  left: 0.4rem;
  top: 0.266667rem;
  z-index: 99;

  .area-box {
    .area-name {
      display: flex;
      align-items: center;
      padding: 0.213333rem 0.266667rem;
      border-radius: 4px;
      font-size: 14px;
      color: #ffffff;
      background: rgba(0, 0, 0, 0.3);
      i {
        font-size: 14px;
        font-weight: normal;
        color: @color-theme;
        margin-right: 0.213333rem;
      }
    }
    .area-info {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 0.266667rem;
      .lf {
        flex: 1;
        .address {
          font-size: 14px;
          color: #333333;
          line-height: 0.56rem;
          height: 0.56rem;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          overflow: hidden;
          white-space: normal;
          width: 100%;
        }
        .distance {
          margin-top: 0.133333rem;
          font-size: 12px;
          color: #999999;
        }
      }
      .rt {
        display: flex;
        align-items: center;
        padding-left: 0.266667rem;
        .line {
          height: 0.8rem;
          width: 1px;
          background: #f1f1f1;
          margin: 0 0.64rem;
        }
        .icon {
          display: flex;
          align-items: center;
          flex-direction: column;
          font-size: 12px;
          color: #999999;

          &.tel {
            position: relative;
          }

          .iconfont {
            color: @color-theme;
          }
        }
      }
    }
  }
  .area_layer {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 9999;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);

    .detail-box {
      max-height: 70%;
      overflow-y: scroll;
      width: 9.2rem;
      border-radius: 4px;
      position: absolute;
      background: #fff;
      padding-bottom: 0.533333rem;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      .subheading {
        font-size: 12px;
        color: #666666;
        margin-top: 0.266667rem;
        font-weight: normal;
      }
      .close {
        position: absolute;
        right: 0;
        top: 0;
        z-index: 99;
        text-align: right;

        .iconcha {
          margin-right: 0.32rem;
          font-size: 12px;
        }
      }

      .title {
        position: sticky;
        left: 0;
        top: 0;
        background: #fff;
        z-index: 99;
        padding-top: 0.266667rem;
        line-height: 0.96rem;
        font-size: 16px;
        font-weight: bold;
        text-align: center;
      }

      .area-list {
        padding: 0 0.4rem;

        .area-name {
          border-radius: 4px;
          margin-top: 0.32rem;
          font-size: 14px;
          color: #666666;
          text-align: center;
          line-height: 0.96rem;
          &.active {
            font-weight: bold;
            color: #333333;
            background: #f6f6f6;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/polymerization/Area.vue